import { useMemo } from 'react';
import {
  qLockedPatientFileIds,
  buildPatientFileLocks,
  type LockedPatientFileRow,
  type PatientFileLocks,
} from '@helios/data-access';
import { usePowerSyncQuery } from '../adapters/powersync';

/**
 * PRD.305 §D4 — which of a patient's files are protected clinical artifacts.
 *
 * Files surfaces call this once and consult the returned map through the shared
 * `canDeletePatientFile` / `canEditPatientFile` guards. Keeping the rule in
 * data-access (rather than as an `if (file.tag === 'lab')` in each component)
 * is what guarantees the three Files surfaces agree, and what leaves every
 * non-laboratory file behaving exactly as it did before.
 *
 * The query is reactive, so publishing a result locks its file everywhere
 * immediately. Before it resolves the map is empty — files behave as they
 * always have rather than all appearing locked.
 */
export function usePatientFileLocks(patientId: string): PatientFileLocks {
  const { data = [] } = usePowerSyncQuery<LockedPatientFileRow>(qLockedPatientFileIds(patientId));
  return useMemo(() => buildPatientFileLocks(data), [data]);
}
